import Byo from './Byo';
import './Byo.scss';

export default Byo;